import { MetricAPI } from '@/common/services/api.core';

const generateUUID = () => {
  let
    d = new Date().getTime(),
    d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
  });
};
const getCurrentDate = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1;
  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${mm}/${dd}/${yyyy}`;
};

// eslint-disable-next-line import/prefer-default-export

const extractCoordinates = (mapboxResponse) => {
  if (!mapboxResponse || !mapboxResponse.geometry.coordinates) {
    return [];
  }
  const [lng, lat] = mapboxResponse.geometry.coordinates;
  return {
    lat,
    lng
  }
}


const extractBbox = (mapboxResponse) => {
  if (!mapboxResponse || !mapboxResponse.bbox) {
    return [];
  }
  return mapboxResponse.bbox;;
}

const extractPlacename = (mapboxResponse) => {
  if (!mapboxResponse || !mapboxResponse.place_name) {
    return null;
  }
  return mapboxResponse.place_name;
}

const handleGeography = (mapboxGeocodingResult) => {
  /**
 * Handles extracting relevant spatial information for insertion into paint-metric-api
 *
 * @param {Object} mapboxGeocodingResult - Mapbox geocoding result (response.result) object. 
 * @param {string} geographyType - value within `types` array defined below. 
 * 
 * @returns {Object} standardized object (needs definition) use to pass to paint metric api
  **/

  // Types are references in Site Locator Channel
  // in PaintCare team.
  // `types` must mirror what is passed via types param in MapboxGeocoder Constructor
  const config = {
    address: {
      coordinates: true,
      bbox: false,
      metadata: false,
      placeName: true,
    },
    country: {
      coordinates: true,
      bbox: true,
      metadata: false,
      placeName: true,
    },
    district: {
      coordinates: true,
      bbox: true,
      metadata: false,
      placeName: true,
    },
    locality: {
      coordinates: true,
      bbox: true,
      metadata: false,
      placeName: true,
    },
    neighborhood: {
      coordinates: true,
      bbox: true,
      metadata: false,
      placeName: true,
    },
    place: {
      coordinates: true,
      bbox: true,
      metadata: false,
      placeName: true,
    },
    postcode: {
      coordinates: true,
      bbox: true,
      metadata: false,
      placeName: true,
    },
    region: {
      coordinates: true,
      bbox: true,
      metadata: false,
      placeName: true,
    }
  }
  if (mapboxGeocodingResult.place_type.length > 1 ) console.warn('Geocoder returned more than one place. Will default to initial load')
  const [ geographyType ] = mapboxGeocodingResult.place_type // TODO: this is an array structure. 

  switch (geographyType) {
    case 'address':

      return {
        lat: config['address'].coordinates ? extractCoordinates(mapboxGeocodingResult).lat : null,
        lng: config['address'].coordinates ? extractCoordinates(mapboxGeocodingResult).lng : null,
        bbox: config['address'].bbox ? extractBbox(mapboxGeocodingResult) : null,
        text: config['address'].placeName ? extractPlacename(mapboxGeocodingResult) : null, 
      }
    case 'country':
      return {
        lat: config['country'].coordinates ? extractCoordinates(mapboxGeocodingResult).lat : null,
        lng: config['country'].coordinates ? extractCoordinates(mapboxGeocodingResult).lng : null,
        bbox: config['country'].bbox ? extractBbox(mapboxGeocodingResult) : null,
        text: config['country'].placeName ? extractPlacename(mapboxGeocodingResult) : null, 
      }
    case 'district':
      return {
        lat: config['district'].coordinates ? extractCoordinates(mapboxGeocodingResult).lat : null,
        lng: config['district'].coordinates ? extractCoordinates(mapboxGeocodingResult).lng : null,
        bbox: config['district'].bbox ? extractBbox(mapboxGeocodingResult) : null,
        text: config['district'].placeName ? extractPlacename(mapboxGeocodingResult) : null 
      }
    case 'locality':
      return {
        lat: config['locality'].coordinates ? extractCoordinates(mapboxGeocodingResult).lat : null,
        lng: config['locality'].coordinates ? extractCoordinates(mapboxGeocodingResult).lng : null,
        bbox: config['locality'].bbox ? extractBbox(mapboxGeocodingResult) : null,
        text: config['locality'].placeName ? extractPlacename(mapboxGeocodingResult) : null 
      }
    case 'neighborhood':
      return {
        lat: config['neighborhood'].coordinates ? extractCoordinates(mapboxGeocodingResult).lat : null,
        lng: config['neighborhood'].coordinates ? extractCoordinates(mapboxGeocodingResult).lng : null,
        bbox: config['neighborhood'].bbox ? extractBbox(mapboxGeocodingResult) : null,
        text: config['neighborhood'].placeName ? extractPlacename(mapboxGeocodingResult) : null 
      }
    case 'place':
      return {
        lat: config['place'].coordinates ? extractCoordinates(mapboxGeocodingResult).lat : null,
        lng: config['place'].coordinates ? extractCoordinates(mapboxGeocodingResult).lng : null,
        bbox: config['place'].bbox ? extractBbox(mapboxGeocodingResult) : null,
        text: config['place'].placeName ? extractPlacename(mapboxGeocodingResult) : null 
      }
    case 'postcode':
      return {
        lat: config['postcode'].coordinates ? extractCoordinates(mapboxGeocodingResult).lat : null,
        lng: config['postcode'].coordinates ? extractCoordinates(mapboxGeocodingResult).lng : null,
        bbox: config['postcode'].bbox ? extractBbox(mapboxGeocodingResult) : null,
        text: config['postcode'].placeName ? extractPlacename(mapboxGeocodingResult) : null 
      }
    case 'region':
      return {
        lat: config['region'].coordinates ? extractCoordinates(mapboxGeocodingResult).lat : null,
        lng: config['region'].coordinates ? extractCoordinates(mapboxGeocodingResult).lng : null,
        bbox: config['region'].bbox ? extractBbox(mapboxGeocodingResult) : null,
        text: config['region'].placeName ? extractPlacename(mapboxGeocodingResult) : null 
      }
    default:
      return 'Unknown type';
  }
}

const getFriendlyTime = (timestamp) => {
  let now = new Date(timestamp);

  let hours = now.getHours();
  let minutes = now.getMinutes();
  let seconds = now.getSeconds();
  
  // Determine AM or PM suffix
  let ampm = hours >= 12 ? 'PM' : 'AM';
  
  // Convert hours to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  
  // Add leading zeros to minutes and seconds if needed
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;
  
  // Format the time string
  let formattedTime = `${hours}:${minutes}:${seconds} ${ampm}`;
  return formattedTime
}

export class MetricHandler {
  constructor() {
    this._sessionId = generateUUID();
    this._sessionDate = getCurrentDate();
    this._api = new MetricAPI();
  }

  handleEvent(eventPayload) {
    // Handles business logic and parsing from different types of events
    const { type, payload } = eventPayload; // type is assumed to be ['session:start', 'session:end']
    switch (type) {
      case 'session:start':
        this.sendEvent(
        {
          eventType: 'session:start',
          deviceType: payload['deviceType'],
          startTime: (getFriendlyTime(payload['timestamp'])),
          isMobile: payload['isMobile']
        })
        break
      case 'load:state-view':
        this.sendEvent(
        {
          eventType: 'load:state-view',
          state: payload['state']
        })
        break
      case 'load:national-view':
        this.sendEvent(
        {
          eventType: 'load:national-view',
        })
        break
      case 'search:home-picklist':
        this.sendEvent(
          {
            eventType: 'search:home-picklist',
            lat: null,
            lon: null,
            bbox: payload['bbox'],
            state: payload['state'],
        })
        break
      case 'search:home-geocoding':
        var { lat, lng, bbox, text } = handleGeography(payload['mapboxResult'])
        this.sendEvent(
          {
            eventType: 'search:home-geocoding',
            lat,
            lng,
            bbox,
            state: payload['state'],
            text
        })
        break
      case 'search:map-picklist':
        this.sendEvent(
          {
            eventType: 'search:map-picklist',
            lat: null,
            lon: null,
            bbox: payload['bbox'],
            state: payload['state'],
        })
        break
      case 'search:map-geocoding':
        var { lat, lng, bbox, text } = handleGeography(payload['mapboxResult'])
        this.sendEvent(
          {
            eventType: 'search:map-geocoding',
            lat,
            lng,
            bbox,
            state: payload['state'],
            text
        })
        break
      case 'search:map-state-switch':
        this.sendEvent(
          {
            eventType: 'search:map-state-switch',
            state: payload['state'],
            bbox: payload['bbox'],
        })
        break
      case 'interaction:marker':
        this.sendEvent(
          {
            eventType: 'interaction:marker',
            siteId: payload['siteId']
        })
        break
      case 'interaction:card':
        this.sendEvent(
          {
            eventType: 'interaction:card',
            siteId: payload['siteId'] 
        })
        break

        default:
          return 
    }
  }

  sendEvent(config) {
    if (!config.eventType) return 
    const payload = {
      ...config,
      sessionId: this._sessionId,
      sessionDate: this._sessionDate
    };
    const options = {
      method: 'POST',
      body: JSON.stringify(payload),
    };

    this._api.makeRequest(options);
  }
}